import { SET_PAGE } from '../actions/types';

export default function page(state = 1, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_PAGE:
				return action.payload;

			// no default
		}
	}

	return state;
}
